import links from "../links.js";
import { Link } from "react-router-dom";
import { useState } from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function Home() {
  const [type, set_type] = useState("all");

  return (
    <Stack sx={styles.container}>
      <Stack spacing={4} direction="row" sx={styles.top}>
        {types.map((x) => (
          <Link key={x} className="link" onClick={() => set_type(x)}>
            <Typography
              sx={{
                textDecoration: type === x && "underline",
                ...styles.left_link,
              }}
              key={x}
            >
              {x}
            </Typography>
          </Link>
        ))}
      </Stack>

      <Stack sx={styles.content} spacing={2}>
        {links
          .filter((x) => type === x.type || type === "all")
          .map((x, i) => {
            return (
              <ProjectLink
                key={x.link}
                link={x.link}
                type={x.type}
                title={x.title}
                subtitle={x.subtitle}
              />
            );
          })}
      </Stack>
    </Stack>
  );
}

function ProjectLink({ link, title, type, subtitle }) {
  const [hover, set_hover] = useState(false);
  return (
    <Link
      onMouseEnter={() => set_hover(true)}
      onMouseLeave={() => set_hover(false)}
      key={link}
      className="link"
      to={`/${type}/${link}`}
    >
      <Stack
        alignItems="end"
        direction="row"
        spacing={2}
        sx={{ borderBottom: hover && "2px solid white" }}
      >
        <Typography
          sx={{
            fontWeight: hover && "bold",
            fontSize: 18,
            pb: 1.6,
            textAlign: "right",
          }}
        >
          {subtitle}
        </Typography>
        <Typography
          sx={{
            fontWeight: hover && "bold",
            fontSize: 50,
            pr: "10px",
            textAlign: "right",
          }}
        >
          {title}
        </Typography>
      </Stack>
    </Link>
  );
}
const types = ["web", "hack", "misc", "all"];

const styles = {
  container: { width: 1, height: 1, justifyContent: "space-between" },

  top: {
    width: 1,
    height: "30px",
    justifyContent: "center",
  },

  content: {
    width: 1,
    alignItems: "flex-end",
    height: "calc(100% - 50px)",
    overflowY: "auto",
  },

  left_link: {
    fontSize: 20,
    "&:hover": { fontWeight: "bold" },
  },
};
